import client from "@https/api";
import type {
    IWishlistCreateRequest,
    IWishlistCreateResponse,
    IWishlistDetailResponse,
    IWishlistEditRequest,
    IWishlistRemoveProductRequest,
    IUpdateProductWishlistsRequest,
    IWishlistsProductsResponse,
    IWishlistCheckResponse,
    IWishlistItem,
} from "@types";
import gate from "../gate";

const wishlistApi = {
    create: (data: IWishlistCreateRequest) =>
        gate.post<IWishlistCreateResponse, IWishlistCreateRequest, never>({
            client,
            url: "user/wishlist",
            data,
        }),

    delete: (id: string | number) =>
        gate.post<any, never, never>({
            client,
            url: `user/wishlist/${id}/delete`,
        }),

    edit: (id: string | number, data: IWishlistEditRequest) =>
        gate.post<any, IWishlistEditRequest, never>({
            client,
            url: `user/wishlist/${id}/edit`,
            data,
        }),

    removeProduct: (id: string | number, data: IWishlistRemoveProductRequest) =>
        gate.post<any, IWishlistRemoveProductRequest, never>({
            client,
            url: `user/wishlist/${id}/removeProduct`,
            data,
        }),

    updateProductWishlists: (data: IUpdateProductWishlistsRequest) =>
        gate.post<any, IUpdateProductWishlistsRequest, never>({
            client,
            url: "user/wishlist/updateProductWishlists",
            data,
        }),

    list: (productId?: number) =>
        gate.get<IWishlistItem[], never, { product_id?: number }>({
            client,
            url: "user/wishlist",
            params: productId ? { product_id: productId } : undefined,
        }),

    getDetail: (id: string | number) =>
        gate.get<IWishlistDetailResponse, never, never>({
            client,
            url: `user/wishlist/${id}/products`,
        }),

    getAllProducts: () =>
        gate.get<IWishlistsProductsResponse, never, never>({
            client,
            url: "user/wishlist/products",
        }),

    check: (id: string | number) =>
        gate.get<IWishlistCheckResponse, never, never>({
            client,
            url: `user/wishlist/${id}/check`,
        }),
};

export default wishlistApi; 